import { ApiKeys, Service } from '../../utils/environment';
import noop from '../../utils/noop';

export default function init(callback = noop, options = {}) {
  const { enableHtmlInAppMessagesInBrazeSdkConfig } = options;
  const brazeKey = ApiKeys.get(Service.braze);
  const brazeBaseUrl = 'https://customer.iad-03.braze.com/api/v3';

  const brazeSdkConfig = {
    baseUrl: brazeBaseUrl,
    minimumIntervalBetweenTriggerActionsInSeconds: 0,
    enableHtmlInAppMessages: !!enableHtmlInAppMessagesInBrazeSdkConfig,
  };

  if (!brazeKey) {
    return;
  }

  (function (a, p, P) {
    a.appboy = {};
    a.appboyQueue = [];
    for (
      var s = 'initialize destroy getDeviceId toggleAppboyLogging setLogger openSession changeUser requestImmediateDataFlush requestFeedRefresh subscribeToFeedUpdates requestContentCardsRefresh subscribeToContentCardsUpdates logCardImpressions logCardClick logCardDismissal logFeedDisplayed logContentCardsDisplayed logInAppMessageImpression logInAppMessageClick logInAppMessageButtonClick logInAppMessageHtmlClick subscribeToNewInAppMessages subscribeToInAppMessage removeSubscription removeAllSubscriptions logCustomEvent logPurchase isPushSupported isPushBlocked isPushGranted isPushPermissionGranted registerAppboyPushMessages unregisterAppboyPushMessages trackLocation stopWebTracking resumeWebTracking wipeData ab ab.DeviceProperties ab.User ab.User.Genders ab.User.NotificationSubscriptionTypes ab.User.prototype.getUserId ab.User.prototype.setFirstName ab.User.prototype.setLastName ab.User.prototype.setEmail ab.User.prototype.setGender ab.User.prototype.setDateOfBirth ab.User.prototype.setCountry ab.User.prototype.setHomeCity ab.User.prototype.setLanguage ab.User.prototype.setEmailNotificationSubscriptionType ab.User.prototype.setPushNotificationSubscriptionType ab.User.prototype.setPhoneNumber ab.User.prototype.setAvatarImageUrl ab.User.prototype.setLastKnownLocation ab.User.prototype.setUserAttribute ab.User.prototype.setCustomUserAttribute ab.User.prototype.addToCustomAttributeArray ab.User.prototype.removeFromCustomAttributeArray ab.User.prototype.incrementCustomUserAttribute ab.User.prototype.addAlias ab.User.prototype.setCustomLocationAttribute ab.InAppMessage ab.InAppMessage.SlideFrom ab.InAppMessage.ClickAction ab.InAppMessage.DismissType ab.InAppMessage.OpenTarget ab.InAppMessage.ImageStyle ab.InAppMessage.TextAlignment ab.InAppMessage.Orientation ab.InAppMessage.CropType ab.InAppMessage.prototype.subscribeToClickedEvent ab.InAppMessage.prototype.subscribeToDismissedEvent ab.InAppMessage.prototype.removeSubscription ab.InAppMessage.prototype.removeAllSubscriptions ab.InAppMessage.prototype.closeMessage ab.InAppMessage.Button ab.InAppMessage.Button.prototype.subscribeToClickedEvent ab.InAppMessage.Button.prototype.removeSubscription ab.InAppMessage.Button.prototype.removeAllSubscriptions ab.SlideUpMessage ab.ModalMessage ab.FullScreenMessage ab.HtmlMessage ab.ControlMessage ab.Feed ab.Feed.prototype.getUnreadCardCount ab.ContentCards ab.ContentCards.prototype.getUnviewedCardCount ab.Card ab.ClassicCard ab.CaptionedImage ab.Banner ab.ControlCard ab.WindowUtils display display.automaticallyShowNewInAppMessages display.showInAppMessage display.showFeed display.destroyFeed display.toggleFeed display.showContentCards display.hideContentCards display.toggleContentCards sharedLib'.split(
          ' '
        ),
        i = 0;
      i < s.length;
      i++
    ) {
      for (var m = s[i], k = a.appboy, l = m.split('.'), j = 0; j < l.length - 1; j++) {
        k = k[l[j]];
      }
      /* eslint-disable no-new-func */
      k[l[j]] = new Function(
        'return function ' +
          m.replace(/\./g, '_') +
          '(){if (window.appboyQueue) window.appboyQueue.push(arguments); return true}'
      )();
      /* eslint-enable */
    }
    window.appboy.getUser = function () {
      return new window.rbiAppboy.ab.User();
    };
    window.appboy.getCachedFeed = function () {
      return new window.rbiAppboy.ab.Feed();
    };
    window.appboy.getCachedContentCards = function () {
      return new window.rbiAppboy.ab.ContentCards();
    };
    window.appboy.initialize(brazeKey, brazeSdkConfig);
    const y = p.createElement(P);
    y.type = 'text/javascript';
    /*
     * We found a bug in the 2.4.1 patch that is being supplied by braze/appboy's CDN.
     * https://rbictg.atlassian.net/browse/CBA-882
     *
     * For now we are pinning to 2.4.0 via jsdelivr CDN
     */
    // y.src = 'https://js.appboycdn.com/web-sdk/2.4/appboy.min.js';
    y.src = 'https://cdn.jsdelivr.net/npm/appboy-web-sdk@2.4.0/appboy.min.js';
    y.async = 1;
    y.onload = () => {
      // Call this function again to get the success value that it return
      a.rbiAppboy = a.appboy;
      const success = a.rbiAppboy.initialize(brazeKey, brazeSdkConfig);

      if (success) {
        a.rbiAppboy.display.automaticallyShowNewInAppMessages();

        a.rbiAppboy.openSession();

        callback();
      }
    };
    const b = p.getElementsByTagName(P)[0];
    b.parentNode.insertBefore(y, b);
  })(window, document, 'script');
}
